import type { Theme } from '@/types';

export const darkTheme: Theme = {
  isDark: true,
  colors: {
    primary: '#8B91FF',
    secondary: '#65C7D3',
    background: '#101218',
    surface: '#171A22',
    text: '#F2F3F6',
    textSecondary: '#A2A7B3',
    accent: '#8B91FF',
    border: '#292D38',
    code: '#E4E6EC',
    codeBg: '#171A22',
  },
  fonts: {
    mono: '"JetBrains Mono", "Fira Code", "Source Code Pro", "Menlo", "Consolas", monospace',
    body: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    heading: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
  },
  sizes: {
    maxWidth: '760px',
    headerHeight: '64px',
  },
};

export const lightTheme: Theme = {
  isDark: false,
  colors: {
    primary: '#5D63D8',
    secondary: '#338D98',
    background: '#FCFCFD',
    surface: '#F6F6F9',
    text: '#20222A',
    textSecondary: '#6C7180',
    accent: '#5D63D8',
    border: '#E6E7EC',
    code: '#252832',
    codeBg: '#F3F3F6',
  },
  fonts: {
    mono: '"JetBrains Mono", "Fira Code", "Source Code Pro", "Menlo", "Consolas", monospace',
    body: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    heading: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
  },
  sizes: {
    maxWidth: '760px',
    headerHeight: '64px',
  },
};
